import ApiClient from "~/admin/services/ApiClient";
import queryString from "query-string";

export default class InfluencersApi {
  static list = () => ApiClient.get("influencers");
  static paginateValid = (searchName = null, page = null) => {
    let params = {};

    params.searchName = searchName;
    params.page = page;

    return ApiClient.get(
      `influencers/paginate-valid?${queryString.stringify(params)}`
    );
  };
  static paginateUnvalided = (page = null) => {
    let params = {};

    params.page = page;
    return ApiClient.get("influencers/paginate-unvalided");
  };
  static get = (influencerId) => ApiClient.get(`influencers/${influencerId}`);
  static validate = (influencerId) =>
    ApiClient.patch(`influencers/${influencerId}/validate`);
}
